///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot = abcsetup.thoughtspot || {};
abcsetup.thoughtspot.booths = abcsetup.thoughtspot.booths || {};
abcsetup.thoughtspot.booths.index = abcsetup.thoughtspot.booths.index || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.thoughtspot.booths.index = {
    init: function() {
        abcsetup.setTitle('ThoughtSpot Booths');

        // Outstanding items delete button clicked
        $(document).on('click', 'table#booths .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete ThoughtSpot Booth', 'Are you sure you want to delete this booth?', function (resp) {
                if (resp) {
                    abcsetup.blockUI(true);
                    axios.delete('/thoughtspot/booths/' + _this.data('id')).then(response => {
                        window.location.reload();
                    });
                }
            });

            return false;
        });
    },
}
